import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import InputField from "../../../Components/Masters/InputField";
import {
  Box,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import SelectField from "../../../Components/Masters/SelectField";
import DynamicTable from "../../../Components/Common/DynamicTable";
import contries from "../../Masters/Roles and Permissions/Country.json";
import EastIcon from "@mui/icons-material/East";
import { restructureData } from "../../../utils/restructureData";
import { get, put } from "../../../utils/api";
import { validateOptionalTable } from "../../../utils/validateTable";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../Components/Masters/MessagePopup";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";
import { useUser } from "../../../context/AuthContext";

const GeneralDisclosure21 = ({ hide }) => {
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);

  const countriesData = [
    {
      fieldName: "countries",
      title: "5. List the countries of operation",
      type: "array",
      fields: [
        {
          fieldName: "country",
          title: "Country",
          width: "15rem",
          type: "select",
          options: contries?.countries || [],
          default: "name",
        },
        {
          fieldName: "additionalDetails",
          title: "Additional Details (Regions/Locations)",
          placeholder: "Enter Text",
          width: "30rem",
          inputWidth: "30rem",
          type: "text",
        },
      ],
    },
  ];

  const [errors, setErrors] = useState({});
  const [tabErrors, setTabErrors] = useState({});
  const [tables, setTables] = useState([]);
  const navigate = useNavigate();
  // const companyDetails = JSON.parse(localStorage.getItem("user"));
  const {user:companyDetails} = useUser();

  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const [griReview, setGriReview] = useState(() =>
    JSON.parse(localStorage.getItem("griReview"))
  );
  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);
  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GeneralDisclosures2021`);
      const res1 = res?.data?.data?.GeneralDisclosures2021?.orgDetails;
      if (
        res?.data?.data?.year ? res?.data?.data?.year < currentYear - 1 : false
      )
        setDisabled(true);
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData({
      name: data?.name || companyDetails?.company?.companyName,
      ownerShipType: data?.ownerShipType || "Publicly Owned",
      legalForm: data?.legalForm || "",
      headQuaters: {
        address1:
          data?.headQuaters?.address1 ||
          companyDetails?.company?.companyAddress,
        address2: data?.headQuaters?.address2 || "",
        pinCode: data?.headQuaters?.pinCode || "",
        country: data?.headQuaters?.country || companyDetails?.company?.country,
        state: data?.headQuaters?.state || "",
      },
      countries: data?.countries || [
        {
          serialNumber: 1,
          country: "",
          additionalDetails: "",
        },
      ],
    });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const [field, key] = name.split(".");

    if (key === "pinCode" && value?.length > 10) return;

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
    if (name.startsWith("headQuaters"))
      setFormData((prev) => ({
        ...prev,
        [field]: { ...prev[field], [key]: value },
      }));
    else
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
  };

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["name", "ownerShipType", "legalForm"];
    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].trim() === "") {
        newErrors[field] = `This field is Required`;
      }
    });

    // Nested validation for headQuaters
    const headQuatersRequiredFields = [
      "address1",
      "pinCode",
      "country",
      "state",
    ];
    Object.keys(formData.headQuaters || {}).forEach((key) => {
      if (
        headQuatersRequiredFields.includes(key) &&
        (!formData.headQuaters[key] || formData.headQuaters[key].trim() === "")
      ) {
        newErrors[`headQuaters.${key}`] = `This field is Required`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  console.log("griReview", griReview);

  const handleSubmit = async () => {
    if (!disabled) {
      let v1 = validateOptionalTable(countriesData, tables, setTabErrors);

      if (!validateForm() || !v1) return;
      let transformedData = restructureData(tables);

      let transformedData2 = {
        orgDetails: {
          ...formData,
          ...transformedData,
        },
        submitted2_1: true,
        type: "GeneralDisclosures2021",
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/general-disclosure/2-2/${id}`);
      } catch (error) {
        console.log(error);
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/general-disclosure/2-2/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <p className={styles.main_heading}>2-1 Organizational Details</p>
      {/* 1 */}
      <p
        className={styles.ques_heading}
        style={{
          marginTop: hide ? "-1rem" : "2.5rem",
          marginBottom: hide ? "-1.5rem" : "0",
        }}
      >
        1. Legal name of the organization
      </p>
      <Box sx={{ ml: 2, width: "46%" }}>
        <InputField
          placeholder={"Enter Text"}
          fieldName="name"
          disabled={disabled}
          value={formData?.name}
          // mt="-5px"
          handleChange={handleChange}
          errors={errors["name"] && true}
        />
        <p
          color="error"
          variant="caption"
          style={{
            lineHeight: "1.2",
            margin: "2px 0",
            marginTop: "5px",
            color: "#d34040",
            fontSize: "10px",
            fontStyle: "italic",
          }}
        >
          {errors["name"]}
        </p>
      </Box>
      {/* 2 */}
      <Box sx={{ display: "flex", gap: 4 }}>
        <Box sx={{ width: "50%" }}>
          <p className={styles.ques_heading}>2. Ownership Type</p>
          <Box sx={{ ml: 2 }}>
            <RadioGroup
              row
              name="ownerShipType"
              value={formData?.ownerShipType || ""}
              onChange={handleChange}
              disabled={disabled}
            >
              <FormControlLabel
                value={"Publicly Owned"}
                control={<Radio disabled={disabled} />}
                label="Publicly Owned"
              />
              <FormControlLabel
                value={"Privately Owned"}
                control={<Radio disabled={disabled} />}
                label="Privately Owned"
              />
            </RadioGroup>
            <p
              color="error"
              variant="caption"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors["ownerShipType"]}
            </p>
          </Box>
        </Box>
        <Box sx={{ width: "50%" }}>
          <p className={styles.ques_heading}>
            3. Legal form of the organization
          </p>
          <Box sx={{ ml: 2 }}>
            <SelectField
              name="legalForm"
              value={formData?.legalForm}
              handleChange={handleChange}
              disable={disabled}
              placeholder={"Enter Text"}
              options={[
                "Incorporated Entity",
                "Partnership",
                "Sole Proprietorship",
                "Nonprofit",
              ]}
              mt="-5px"
              errors={errors["legalForm"] && true}
            />
            <p
              color="error"
              variant="caption"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors["legalForm"]}
            </p>
          </Box>
        </Box>
      </Box>
      <p
        className={styles.ques_heading}
        style={{ marginBottom: hide ? "-0.8rem" : "0.2rem" }}
      >
        4. Location of headquarters of the organization
      </p>
      <Box sx={{ display: "flex", gap: 4, ml: 2 }}>
        {["address1", "address2", "pinCode"].map((el) => (
          <Box sx={{ width: "25%" }}>
            <InputField
              placeholder={
                el === "address1"
                  ? "Address Line 1"
                  : el === "address2"
                  ? "Address Line 2"
                  : "Pincode"
              }
              value={formData?.headQuaters?.[el]}
              fieldName={`headQuaters.${el}`}
              handleChange={handleChange}
              disabled={disabled}
              mt="0"
              errors={errors[`headQuaters.${el}`] && true}
            />
            <p
              color="error"
              variant="caption"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors[`headQuaters.${el}`]}
            </p>
          </Box>
        ))}
      </Box>
      <Box sx={{ display: "flex", gap: 4, ml: 2 }}>
        <Box sx={{ width: "25%" }}>
          <SelectField
            defaultValue={"Country"}
            value={formData?.headQuaters?.country}
            name={"headQuaters.country"}
            options={contries.countries}
            disable={disabled}
            handleChange={handleChange}
            errors={errors["headQuaters.country"] && true}
          />
          <p
            color="error"
            variant="caption"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
            }}
          >
            {errors["headQuaters.country"]}
          </p>
        </Box>
        <Box sx={{ width: "25%" }}>
          <InputField
            defaultValue={"State"}
            value={formData?.headQuaters?.state}
            options={contries.countries}
            disabled={disabled}
            fieldName={"headQuaters.state"}
            handleChange={handleChange}
            placeholder={"State"}
            errors={errors["headQuaters.state"] && true}
          />
          <p
            color="error"
            variant="caption"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
            }}
          >
            {errors["headQuaters.state"]}
          </p>
        </Box>
      </Box>
      <DynamicTable
        {...{
          inputData: countriesData,
          tables,
          setTables,
          errors: tabErrors,
          disabled: disabled,
          setErrors: setTabErrors,
          data,
          hide,
        }}
      />
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          <Unauthorized requiredModule="ESG Reporting | GRI">
            {renderContent({ hide })}

            <>
              {!griReview ? (
                <Box sx={{ ml: "1rem", width: "98%" }}>
                  <ReviewBox
                    url={`/gri/review/${id}`}
                    handleSubmit={handleSubmit}
                  />
                </Box>
              ) : (
                <Box textAlign="right" sx={{ mt: 3 }}>
                  <Button
                    onClick={handleSubmit}
                    variant="contained"
                    sx={{
                      bgcolor: "#1C486B",
                      textTransform: "none",
                      mt: 3,
                      mb: 5,
                    }}
                  >
                    Save & Continue <EastIcon sx={{ ml: 2 }} />
                  </Button>
                </Box>
              )}
            </>
          </Unauthorized>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GeneralDisclosure21;
